import React from 'react';
import '../../styles/UI-components/badge.scss';

const Badge = ({ text, className = '' }) => {
    if (!text) {
        return null;
    }

    return (
        <span className={`badge ${className}`}>
            {text}
        </span>
    );
};

export default Badge;